// extracted by mini-css-extract-plugin
export default {"home":"updatevedio_home__Fj21V","hr":"updatevedio_hr__CfpaN","home2":"updatevedio_home2__KYhrK","main":"updatevedio_main__2UYBl"};